import { useState, useEffect, useCallback } from 'react';
import { getJobOrders } from '../services/job-order-service';

// Fetches every job order (each carrying door/window/adder line items) for
// cross-order analytics. One-shot fetch, not a live listener — analytics
// don't need real-time updates.
export function useJobOrders() {
  const [jobOrders, setJobOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(() => {
    setLoading(true);
    setError(null);
    getJobOrders()
      .then(setJobOrders)
      .catch(err => {
        console.error('Error fetching job orders:', err);
        setError(err);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { jobOrders, loading, error, refresh };
}

export default useJobOrders;
